import React, { useRef } from "react"
import { storyblokEditable, renderRichText } from "gatsby-source-storyblok";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { Href } from "../utils/helper";

const HomeCarousel = ({blok}) => {
  // console.log(blok)

  let sliderRef = useRef(null)

  const PrevArrow = (props) => {
    const { className, style, onClick } = props
    return (
      <button onClick={onClick} className="absolute top-[390px] sm:top-1/2 left-0 sm:left-5 z-10">
        <img className="w-[20px] sm:w-[40px] sm:h-[40px]" src="/icons/circle-left-arrow.svg" alt="Prev button"/>
      </button>
    )
  }

  const NextArrow = (props) => {
    const { className, style, onClick } = props
    return (
      <button onClick={onClick} className="absolute top-[390px] sm:top-1/2 right-0 sm:right-5 z-10">
        <img className="w-[20px] sm:w-[40px] sm:h-[40px]" src="/icons/circle-right-arrow.svg" alt="Next button"/>
      </button>
    )
  }

  const heightClass = {
    'default': 'h-0 md:h-[75vh]',
    'full': 'h-0 md:h-[calc(100vh-77px)]',
  }

  const settings = {
    autoplay: blok.autoplay,
    fade: blok.animationType === 'fade' ? true : false,
    infinite: true,
    dots: true,
    autoplaySpeed: 10000,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const positionClass = {
    left: 'sm:left-[5%]',
    center: 'sm:left-1/2 sm:-translate-x-1/2',
    right: 'sm:right-[5%]',
  };

  const verticalClass = {
    top: 'top-0',
    center: 'top-1/2 sm:-translate-y-1/2',
    bottom: 'bottom-0',
  };

  const alignClass = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
  };

  const flexJustifyClass = {
    left: 'justify-start',
    center: 'justify-center',
    right: 'justify-end',
  };

  const sliderItem = (item) => {
    const isVideoDesktop = item.bgDesktop?.filename?.includes('.mp4')
    const isVideoMobile = item.bgMobile?.filename?.includes('.mp4')
    const opacity = parseInt(item.overlay) / 100

    return (
    <div key={item._uid} id={item._uid} className="relative w-full text-white text-left" {...storyblokEditable(item)}>
      <div style={{backgroundColor: `rgba(0,0,0,${opacity})`}} className={`absolute w-full ${heightClass[blok.height]}`}></div>
      {!(isVideoMobile || isVideoDesktop) &&<img loading="lazy" src={item.bgMobile?.filename ? `${item.bgMobile?.filename}/m/` : `${item.bgDesktop?.filename}/m/`} alt={item.bgMobile?.alt} 
        className="w-full h-[400px] md:h-0 object-cover object-bottom"/>}
      {(isVideoMobile || isVideoDesktop) && <video loading="lazy" src={item.bgMobile?.filename ? item.bgMobile?.filename : item.bgDesktop?.filename} autoPlay loop muted playsInline
        className={`w-full h-[400px] md:h-0 object-cover object-bottom`} /> }
      {!isVideoDesktop && <img loading="lazy" src={`${item.bgDesktop?.filename}/m/`} alt={item.bgDesktop.alt} 
        className={`w-full ${heightClass[blok.height]} object-cover`}/>}
      {isVideoDesktop && <video loading="lazy" src={item.bgDesktop?.filename} autoPlay loop muted playsInline
        className={`w-full ${heightClass[blok.height]} object-cover`} /> }

      <div style={{backgroundColor: item.bgColor?.color ? item.bgColor.color : '#999999' }} 
        className={`max-w-7xl min-h-[400px] sm:min-h-auto mx-auto relative sm:absolute sm:!bg-transparent p-6 md:p-12 md:pb-20 ${positionClass[item.position]} ${verticalClass[item.verticalPosition]}`}>
        <div className={`md:max-w-xl ${alignClass[item.textAlign]}`}>
          <div className="mb-4">
            <img loading="lazy" src={`/icons/${item.icon}`} alt="icon" className="!inline-block mr-3"/>
            <span className="border-b-2">{item.subHeading}</span>
          </div>
          <h2 className="text-3xl md:text-5xl mb-4 font-serif !leading-snug">{item.tagLine}</h2>
          
          <div className="sm:text-lg leading-relaxed" dangerouslySetInnerHTML={{__html: renderRichText(item.description)}} />
          
          <div className="inline-block">
            <a href={Href(item.ctaUrl)} className="inline-flex items-baseline text-lg border-2 rounded-xl py-2 px-10 mt-6 mr-8 xl:mt-8 w-fit"
              style={{borderColor: item.ctaColor?.color, color: item.ctaTextColor?.color, backgroundColor: item.ctaStyle == 'fill' ? item.ctaColor?.color : 'transparent'}}>
              <div>{item.ctaText}</div>
              {/* <img className="w-[36px] h-[13px] ml-4" src="/icons/newsletter-cta-arrow-right.svg"/> */}
            </a>

            {item.ctaText2 &&
            <a href={Href(item.ctaUrl2)} className="inline-flex items-baseline text-lg border-2 rounded-xl py-2 px-10 mt-6 xl:mt-8 w-fit"
              style={{borderColor: item.ctaColor2?.color, color: item.ctaTextColor2?.color, backgroundColor: item.ctaStyle2 == 'fill' ? item.ctaColor2?.color : 'transparent'}}>
              <div>{item.ctaText2}</div>
            </a>
            }
          </div>
        </div>
      </div>
    </div>
  )}
  
  return (
    <div className="slider-container home-carousel" {...storyblokEditable(blok)}>
      <Slider ref={sliderRef} {...settings}>{blok.carouselItems.map(blok => (sliderItem(blok)))}</Slider>
    </div>
  );
};
  
export default HomeCarousel
